export enum ReportingFeedbackTypeEnum {
    FEEDBACK = "feedback",
    PERFORMANCE = "performance",
    ATTITUDE = "attitude",
    WORK_SAMPLE = "work_sample"
}
